import { Phone } from "lucide-react";
import { trackEvent } from "./track";
import { useI18n } from "../../i18n";
import { CONSULTANTS_SUCCESS_PHONE } from "./phone";

export const FloatingCall = () => {
  const { t } = useI18n();
  return (
    <div className="floating-call-wrap md:hidden">
      <a
        href={CONSULTANTS_SUCCESS_PHONE.tel}
        aria-label={t("call.ariaOpen")}
        className="floating-call"
        onClick={() => trackEvent("phone_call", { phone_label: t("call.ariaOpen"), phone_number: CONSULTANTS_SUCCESS_PHONE.display })}
        data-testid="floating-call-button"
      >
        <Phone size={22} strokeWidth={2} />
      </a>
    </div>
  );
};

export default FloatingCall;
